module.exports = __webpack_public_path__ + "static/media/m_beard_tailored_round__oval.f7842ac3.png";